['click', 'scroll', 'mousemove', 'touchstart'].forEach(function (e) {
  window.addEventListener(e, loadReviews, {
    once: true,
  });
});
var userInteracted = false;

let totalPages,
  apiKeyPublic,
  storeUrl,
  pageTypeShopify,
  boughtText,
  reviews,
  imageData,
  url,
  reviewsCarousel,
  reviewsCarouselSectionId,
  reviewProductId,
  verifiedReviewsText;
let reviewsSection = document.querySelector('reviews'),
  reviewsWrapper = document.querySelector('reviews .reviews-wrapper'),
  reviewsPerPage = parseInt(
    document.querySelector('reviews').dataset.itemsPerPage
  ),
  currentPage = 1,
  totalPagesElm = document.getElementById('totalPages'),
  pageContent = document.getElementById('pageContent'),
  prevBtn = document.getElementById('prevBtn'),
  nextBtn = document.getElementById('nextBtn'),
  prevNextBtn = document.querySelectorAll('.prev-next-btn'),
  imageSliderNextBtn = document.querySelector(
    '.slider-reviews-images .slider-button--next'
  ),
  currentPageElm = document.getElementById('currentPage'),
  pageContentWrapper = document.querySelector('.page-content-wrapper'),
  reviewsFilterElm = document.querySelector('.reviews-filter'),
  reviewsFilters = document.querySelectorAll('.reviews-filter .filter-item'),
  filterItem = 'filter-item',
  reviewsPlaceholder = document.querySelector('.reviews-placeholder'),
  reviewsCarouselList = document.querySelector('.reviews-carousel__list'),
  imagesFirstTake = 10,
  reviewsPageReviewsWidget = document.querySelector(
    '.reviews-page .reviews-widget'
  );

if (reviewsSection != null || reviewsSection != undefined) {
  apiKeyPublic = reviewsSection.dataset.stampedApiKey;
  storeUrl = reviewsSection.dataset.stampedStoreHash;
  pageTypeShopify = reviewsSection.dataset.pageType;
  verifiedReviewsText = reviewsSection.dataset.stampedBadgeVerifiedText;
  boughtText = reviewsSection.dataset.boughtText;
}

if (document.querySelector('.reviews-carousel') != null) {
  reviewsCarousel = document.querySelector('.reviews-carousel');
  reviewsCarouselSectionId = reviewsCarousel.dataset.sectionId;
}

const defineFetchUrl = (currentPage, filterTag) => {
  let fetchUrl;

  if (pageTypeShopify == 'product') {
    reviewProductId = reviewsSection.dataset.productId;
    fetchUrl = `https://stamped.io/api/widget/reviews?productId=${reviewProductId}&productType&productTitle&email&minRating&take=${reviewsPerPage}&page=${currentPage}&dateFrom&dateTo&sortReviews=photos&tags&storeUrl=${storeUrl}&apiKey=${apiKeyPublic}`;
  } else {
    if (reviewsSection.dataset.reviewsFilter == undefined) {
      fetchUrl = `https://stamped.io/api/widget/reviews?productId&productType&productTitle&email&minRating&take=${reviewsPerPage}&page=${currentPage}&dateFrom&dateTo&sortReviews=photos&tags&storeUrl=${storeUrl}&apiKey=${apiKeyPublic}`;
    } else {
      fetchUrl = `https://stamped.io/api/widget/reviews?productId&productType&productTitle&email&minRating&take=${reviewsPerPage}&page=${currentPage}&dateFrom&dateTo&sortReviews=photos&tags=${filterTag}&storeUrl=${storeUrl}&apiKey=${apiKeyPublic}`;
    }
  }

  return fetchUrl;
};

const fetchReviews = (currentPage, filterTag) => {
  url = defineFetchUrl(currentPage, filterTag);

  setReviewsVisibility(false);

  const reviewsData = fetch(url, {
    method: 'get',
  }).then((data) => data.json());
  const allData = Promise.all([reviewsData]);
  allData
    .then((res) => {
      reviews = res[0];
      if (reviews.data.length !== 0) {
        setReviewsSectionVisibility(true);
        initSection(reviews);
        handleReviews(reviews);
        return res;
      } else {
        setReviewsSectionVisibility(false);
      }
    })
    .then(function () {
      setReviewsVisibility(true);
    })
    .catch((e) => {
      console.error(e);
    });
};


const initSection = (reviews) => {
  // get the reviews total and update elements on page
  let totalReviews = reviews.total;
  totalPages = Math.ceil(totalReviews / reviewsPerPage);

  if (pageTypeShopify != 'product') {
    document.getElementById('reviewsTotal').innerText = totalReviews;
  }
  if (totalPagesElm != null || totalPagesElm != undefined) {
    totalPagesElm.innerText = totalPages;
  }
};

const setReviewsVisibility = (setting) => {
  // toggle visibility of reviews block while fetching
  if (reviewsPlaceholder == undefined) {
    return;
  }
  if ((setting = true)) {
    reviewsPlaceholder.classList.add('hidden');
    reviewsWrapper.classList.remove('invisible');
  } else {
    reviewsPlaceholder.classList.remove('hidden');
    reviewsWrapper.classList.add('invisible');
  }
};

const setReviewsSectionVisibility = (setting) => {
  // only on product page, to hide or show whole reviews section depending on reviews length
  if (pageTypeShopify != 'product') {
    return;
  }
  if (setting == true) {
    document.querySelector('.section.reviews').classList.remove('hidden');
  } else {
    document.querySelector('.section.reviews').classList.add('hidden');
  }
};

prevNextBtn.forEach((btn) => {
  btn.addEventListener('click', () => {
    scrollToReviews();
    pageUpdate(btn);
  });
});

const handleReviews = (reviews) => {
  pageContent.innerHTML = '';
  reviews.data.forEach((review) => {
    const {
      author,
      dateCreated,
      reviewTitle,
      reviewMessage,
      reviewUserPhotos,
      productName,
      productUrl,
      productId,
      id,
      reviewRating,
    } = review;

    const pastDays = timeDifference(dateCreated);
    pageContent.innerHTML += `
    <div class="page-item review-${id}">
      <div class="review-author">
        <span class="review-author__name text--tiny">${author}</span>
        <span class="review-author__badge badge badge--verified">
        <svg class="icon-verified" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.11921 0.309673C6.60202 -0.103224 7.39273 -0.103224 7.88254 0.309673L8.98813 1.26143C9.19805 1.44339 9.5899 1.59035 9.8698 1.59035H11.0594C11.8011 1.59035 12.4098 2.1992 12.4098 2.94101V4.13072C12.4098 4.40365 12.5568 4.80255 12.7387 5.0125L13.6904 6.11822C14.1032 6.6011 14.1032 7.3919 13.6904 7.88178L12.7387 8.9875C12.5568 9.19745 12.4098 9.58935 12.4098 9.86928V11.059C12.4098 11.8008 11.8011 12.4096 11.0594 12.4096H9.8698C9.5969 12.4096 9.19805 12.5566 8.98813 12.7386L7.88254 13.6903C7.39973 14.1032 6.60902 14.1032 6.11921 13.6903L5.01362 12.7386C4.8037 12.5566 4.41185 12.4096 4.13195 12.4096H2.9214C2.17968 12.4096 1.57091 11.8008 1.57091 11.059V9.86228C1.57091 9.58935 1.42397 9.19745 1.24903 8.9875L0.304386 7.87478C-0.101462 7.3919 -0.101462 6.6081 0.304386 6.12522L1.24903 5.0125C1.42397 4.80255 1.57091 4.41065 1.57091 4.13772V2.93402C1.57091 2.1922 2.17968 1.58335 2.9214 1.58335H4.13195C4.40485 1.58335 4.8037 1.43639 5.01362 1.25444L6.11921 0.309673Z" fill="#F50D3A"/>
          <path d="M4.88843 7.00053L6.29426 8.4122L9.11176 5.58887" stroke="white" stroke-width="0.670807" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        ${verifiedReviewsText}
        </span>
      </div>
      <div class="review-rating">
        <span class="review-rating__stars">
          <i class="stamped-fa stamped-fa-star" style="color:#efca23 !important;" aria-hidden="true"></i>
          <i class="stamped-fa stamped-fa-star" style="color:#efca23 !important;" aria-hidden="true"></i>
          <i class="stamped-fa stamped-fa-star" style="color:#efca23 !important;" aria-hidden="true"></i>
          <i class="stamped-fa stamped-fa-star" style="color:#efca23 !important; ${
            reviewRating < 4 && 'display: none'
          }" aria-hidden="true"></i>
          <i class="stamped-fa stamped-fa-star" style="color:#efca23 !important; ${
            reviewRating < 5 && 'display: none'
          }" aria-hidden="true"></i>
        </span>
        <span class="review-rating__days-history">${
          window.stampedLanguage.daysAgoPreText
        } ${pastDays} ${window.stampedLanguage.daysAgoPostText}</span>
      </div>
      <div class="review-product-url text__title"
        ${productName ? true : "style = 'display:none'"}
      > ${boughtText} <a href="${productUrl}" target="_blank" class="color-raspberry">${productName}</a> </div>
      <div class="review-content" onclick="openReviewPhoto(${id}, ${reviewProductId})">
        <p class="review-content__title">${reviewTitle}</p>
        <p class="review-content__message text--small color-gray-light">${reviewMessage}</p>
        <div class="review-content__media"></div>
      </div>
    </div>
  `;

    pageContentWrapper.style.minHeight =
      pageContent.getBoundingClientRect().height + 'px';

    if (reviewUserPhotos == undefined) {
      return;
    }

    handleReviewsImages(review);
  });
};

function openReviewPhoto(id, reviewProductId) {
  StampedFn.openUGCPhoto(id, reviewProductId, 0, true);
}

const handleReviewsImages = (review) => {
  let photos = review.reviewUserPhotos.split(',');
  if (photos != undefined && photos.length > 0) {
    photos.forEach((photo) => {
      const imgUrl = 'https://cdn.stamped.io/tr:h-180,/uploads/photos/' + photo;
      pageContent.querySelector(
        `.review-${review.id} .review-content__media`
      ).innerHTML += `
        <img ${review.reviewUserPhotos ? '' : "style='display:none'"} src="${
        photo ? imgUrl : ''
      }" alt="${review.productName} review" loading="lazy"
          ></img>
      `;
    });
  }
};

const fetchReviewsImages = (take, page) => {
  let imageUrl;

  if (pageTypeShopify == 'product') {
    reviewProductId = reviewsSection.dataset.productId;
    imageUrl = `https://stamped.io/api/widget/reviews?productId=${reviewProductId}&isWithPhotos=true&take=${take}&page=${page}&storeUrl=${storeUrl}&apiKey=${apiKeyPublic}`;
  } else {
    imageUrl = `https://stamped.io/api/widget/reviews?isWithPhotos=true&take=${take}&page=${page}&storeUrl=${storeUrl}&apiKey=${apiKeyPublic}`;
  }

  fetch(imageUrl)
    .then((response) => response.json())
    .then((data) => {
      addImage(data);

      if (data.data.length > 6) {
        document
          .querySelector('.slider-reviews-images')
          ?.classList.remove('hide-slider-buttons');
      }

      document.querySelector('.reviews-carousel slider-component').initSlider()
    })
    .catch((e) => {
      console.error(e);
    });

  const addImage = (data) => {
    let images = data.data;

    images.forEach((image) => {
      const { reviewUserPhotos, id, reviewProductId } = image;
      if (reviewUserPhotos) {
        let photos = reviewUserPhotos.split(',');
        photos.forEach((photo, i) => {
          if (document.getElementById(`Slide-${id}-${i}`) != undefined) {
            return;
          } // prevent duplicated items
          let imageItem = document.createElement('li');
          imageItem.id = `Slide-${id}-${i}`;
          imageItem.classList.add('slider__slide');
          imageItem.classList.add('swiper-slide');
          const imgUrl =
            'https://cdn.stamped.io/tr:h-180,/uploads/photos/' + photo;
          imageItem.style.backgroundImage = `url(${imgUrl})`;
          imageItem.classList.add('has-image');
          imageItem.setAttribute(
            'onclick',
            `openReviewPhoto(${id},${reviewProductId})`
          );
          imageItem.style.zIndex = '2';
          reviewsCarouselList.appendChild(imageItem);
        });
      }
    });
  };
};

const scrollToReviews = () => {
  const y =
    reviewsSection.getBoundingClientRect().top +
    document.documentElement.scrollTop -
    150;
  window.scrollTo({
    top: y,
    behavior: 'smooth',
  });
};

const pageUpdate = (btn) => {
  if (btn.dataset.control == 'next' && currentPage < totalPages) {
    currentPage++;
    currentPageElm.innerText = currentPage;
    fetchUponPageUpdate();
  } else if (btn.dataset.control == 'prev' && currentPage > 1) {
    currentPage--;
    currentPageElm.innerText = currentPage;
    fetchUponPageUpdate();
  }
};

const fetchUponPageUpdate = () => {
  if (reviewsSection.dataset.reviewsFilter == undefined) {
    fetchReviews(currentPage);
  } else {
    let filterTag = document.querySelector('.filter-item.active').dataset
      .filterTag;
    fetchReviews(currentPage, filterTag);
  }
};

document.addEventListener('click', (e) => {
  if (e.target.classList.contains(filterItem)) {
    scrollToReviews();
    currentPage = 1;
    currentPageElm.innerText = currentPage;
    for (let i = 0; i < reviewsFilters.length; i++) {
      let targetIndex = e.target.dataset.filterItemIndex;
      let filterTag = e.target.dataset.filterTag;
      if (targetIndex != i) {
        reviewsFilters[i].classList.remove('active');
        fetchReviews(currentPage, filterTag);
      } else {
        fetchReviews(currentPage, filterTag);
        reviewsFilters[i].classList.add('active');
        reviewsSection.setAttribute('data-reviews-filter', 'true');
      }
    }
  }
});

const timeDifference = (time) => {
  let date = new Date();
  let now = date.getTime();
  let past = new Date(time);
  let differenceInDays = Math.floor((now - past) / 86400000);
  return differenceInDays;
};

if (reviewsPageReviewsWidget) {
  document.addEventListener('scroll', () => {
    if (
      window.scrollY >= reviewsPageReviewsWidget.offsetTop &&
      window.scrollY <
        reviewsPageReviewsWidget.offsetTop +
          reviewsPageReviewsWidget.offsetHeight -
          300
    ) {
      if (!reviewsFilterElm.classList.contains('fixed')) {
        reviewsFilterElm.classList.add('fixed');
      }
    }
    if (
      window.scrollY < reviewsPageReviewsWidget.offsetTop ||
      window.scrollY >=
        reviewsPageReviewsWidget.offsetTop +
          reviewsPageReviewsWidget.offsetHeight
    ) {
      if (reviewsFilterElm.classList.contains('fixed')) {
        reviewsFilterElm.classList.remove('fixed');
      }
    }
  });
}

function loadReviews() {
  if (!userInteracted) {
    fetchReviews(currentPage, '');

    if (pageTypeShopify == 'product') {
      fetchReviewsImages(imagesFirstTake, 1);

      let currentCounter = document.querySelector(
        '.slider-reviews-images .slider-counter--current'
      );

      // const currentCounterObserver = new MutationObserver((mutations) => {
      //   fetchReviewsImages(1, imagesFirstTake++);
      // });

      // currentCounterObserver.observe(currentCounter, {
      //   characterData: false,
      //   attributes: false,
      //   childList: true,
      //   subtree: false,
      // });
    }

    userInteracted = true;
  }
}

window.addEventListener('DOMContentLoaded', function () {
  let check = setInterval(() => {
    if (document.querySelector('#review_anchor') == undefined) {
      return;
    }
    clearInterval(check);

    document.addEventListener('click', el => {      
      if (el.target.classList.contains('anchor_trigger')) {
        var offsets = document.querySelector('#review_anchor')?.getBoundingClientRect();
        var top = offsets.top + window.scrollY;
        window.scrollTo({
          top: top,
          left: 0,
          behavior: 'smooth',
        });

        let videoThumbnails = document.querySelector('video-thumbnails');
        if (videoThumbnails) { videoThumbnails.resetAndCloseVideos() }
      }
    })

  }, 500);
});

window.addEventListener('DOMContentLoaded', function () {
  const interval = setInterval(() => {
    if (window.StampedFn !== null) {
      clearInterval(interval);
      StampedFn.init();
    }
  }, 1000);
});
